var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isVisible)?_c('transition',{attrs:{"name":"modal-window-container"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container",class:{
          'borderless-container': _vm.borderType == 'borderless',
          'normal-container': _vm.borderType == 'normal',
        }},[_vm._t("default")],2)])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }